import React from 'react'
import PropTypes from 'prop-types'

import { Button, Form, Header } from 'semantic-ui-react'

import Container from './SearchFormContainer'
import Enhancer from './SearchFormEnhancer'

import ExtendedSearchModal from 'Components/ExtendedSearchModal'
import FormInputDropdown from 'Components/FormInputDropdown'
import FormInputText from 'Components/FormInputText'
import Permissions from 'Components/Permissions'

import * as options from './options'
import * as styles from './styles'

const SearchForm = props => {
  const {
    extendedFilters,
    extendedFiltersModalOpen,
    form,
    handleCustomer,
    handleDessin,
    handleHeightMax,
    handleHeightMin,
    handleIdOrName,
    handleOrderYearMax,
    handleOrderYearMin,
    handleProducer,
    handleQuality,
    handleReset,
    handleSave,
    handleStatus,
    handleSubmit,
    handleWidthMax,
    handleWidthMin,
    statusOptions,
    toggleExtendedFiltersModal,
  } = props

  const { customer, dessin, height, idOrName, orderYear, producer, quality, status, width } = form

  return (
    <Form size="tiny">
      <FormInputText icon="tag" name="idOrName" onChange={handleIdOrName} text="ID or Name" value={idOrName} />

      <Permissions
        permissions="rug.field.belCustomer"
        render={() => <FormInputText icon="user" name="customer" onChange={handleCustomer} text="Customer" type="text" value={customer} />}
      />

      <Permissions
        permissions="rug.field.edges"
        render={() => <FormInputDropdown name="dessin" onChange={handleDessin} options={options.dessin} text="Edges" value={dessin} />}
      />

      <Permissions
        permissions="rug.field.quality"
        render={() => (
          <FormInputDropdown name="quality" onChange={handleQuality} options={options.quality} text="Quality" value={quality} />
        )}
      />

      <Permissions
        permissions="rug.field.producerCode"
        render={() => (
          <FormInputDropdown name="producer" onChange={handleProducer} options={options.producer} text="Producer" value={producer} />
        )}
      />

      <Permissions
        permissions="rug.field.status"
        render={() => <FormInputDropdown name="status" onChange={handleStatus} options={statusOptions} text="Status" value={status} />}
      />

      <Permissions
        permissions="rug.field.size"
        render={() => (
          <div>
            <Header as="h5" content="Width (cm)" style={styles.header} />
            <Form.Group>
              <FormInputText
                icon="resize horizontal"
                name="widthMin"
                onChange={handleWidthMin}
                text="from"
                type="number"
                value={width.min}
                noLabel
              />

              <FormInputText
                icon="resize horizontal"
                name="widthMax"
                onChange={handleWidthMax}
                text="to"
                type="number"
                value={width.max}
                noLabel
              />
            </Form.Group>

            <Header as="h5" content="Length (cm)" style={styles.header} />
            <Form.Group>
              <FormInputText
                icon="resize vertical"
                name="heightMin"
                onChange={handleHeightMin}
                text="from"
                type="number"
                value={height.min}
                noLabel
              />

              <FormInputText
                icon="resize vertical"
                name="heightMax"
                onChange={handleHeightMax}
                text="to"
                type="number"
                value={height.max}
                noLabel
              />
            </Form.Group>
          </div>
        )}
      />

      <Permissions
        permissions="rug.field.dateOrder"
        render={() => (
          <div>
            <Header as="h5" content="Order Year" style={styles.header} />
            <Form.Group>
              <FormInputText icon="calendar" name="orderYearMin" onChange={handleOrderYearMin} text="from" value={orderYear.min} noLabel />

              <FormInputText icon="calendar" name="orderYearMax" onChange={handleOrderYearMax} text="to" value={orderYear.max} noLabel />
            </Form.Group>
          </div>
        )}
      />

      <Form.Group style={styles.buttonGroup}>
        <Button color="black" content="Search" icon="search" onClick={handleSubmit} />

        <Permissions
          permissions={[
            'rug.field.advisor',
            'rug.field.dateReceipt',
            'rug.field.description',
            'rug.field.pictureSource',
            'rug.field.requests',
            'rug.field.reservations',
            'rug.field.size',
          ]}
          render={() => (
            <Button
              color={extendedFilters.active ? 'blue' : 'black'}
              content="Extended"
              icon="settings"
              onClick={toggleExtendedFiltersModal}
            />
          )}
        />

        <Permissions
          permissions="modules.mySearches"
          render={() => <Button color="black" content="Save" icon="save" onClick={handleSave} />}
        />

        <Button color="black" content="Reset" icon="erase" onClick={handleReset} />
      </Form.Group>

      <br />

      {extendedFiltersModalOpen && (
        <ExtendedSearchModal applyFilters={handleSubmit} open={extendedFiltersModalOpen} toggle={toggleExtendedFiltersModal} />
      )}
    </Form>
  )
}

SearchForm.propTypes = {
  extendedFilters: PropTypes.object.isRequired,
  extendedFiltersModalOpen: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  handleCustomer: PropTypes.func.isRequired,
  handleDessin: PropTypes.func.isRequired,
  handleHeightMax: PropTypes.func.isRequired,
  handleHeightMin: PropTypes.func.isRequired,
  handleIdOrName: PropTypes.func.isRequired,
  handleOrderYearMax: PropTypes.func.isRequired,
  handleOrderYearMin: PropTypes.func.isRequired,
  handleProducer: PropTypes.func.isRequired,
  handleQuality: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleWidthMax: PropTypes.func.isRequired,
  handleWidthMin: PropTypes.func.isRequired,
  statusOptions: PropTypes.array.isRequired,
  toggleExtendedFiltersModal: PropTypes.func.isRequired,
}

export default Enhancer(Container(SearchForm))
